// src/components/BusinessSuite/schedule/index.js
import { useState } from 'react';
import ScheduleTabs from './ScheduleTabs';
import CalendarView from './Calendar/CalendarView';
import TimeOffView from './TimeOff/TimeOffView';
import { useLocation } from 'react-router-dom';

export default function ScheduleRoot() {
  const [tab, setTab] = useState('calendar');
  const location = useLocation();
  const currentBusinessId = location.state?.currentBusinessId ?? null;
  console.log(currentBusinessId);
  return (
    <div className="p-4">
      <h1 className="text-2xl font-semibold mb-4">Employee Scheduling</h1>
      <ScheduleTabs active={tab} onChange={setTab} />
      {tab === 'calendar'
        ? <CalendarView businessId={currentBusinessId} />
        : <TimeOffView   businessId={currentBusinessId} />}
    </div>
  );
}
